import moment from "moment";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { BiSolidEdit } from "react-icons/bi";
import { BiDetail } from "react-icons/bi";
import { BsTrash3Fill } from "react-icons/bs";
import { IoArrowBackSharp, IoReceiptSharp } from "react-icons/io5";
import { withRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { Button, Col, Row, Table, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import swal from "sweetalert";
import {
  convertDataFromSnakeCaseToCamelCase,
  convertToDateString,
  LoadingSpinner,
} from "../../constants/const";
import { encryptStorage } from "../../constants/EncryptStorage";
import { GetLanguageString, NoResult } from "../helper/Components";
import { GetCustomStyles, GetSelectedLanguage } from "../helper/Method";
import { ApiFinance } from "./ApiFinance";
import { viewReceiptPdf } from "../shared/receiptViewer";
import EditExpenseFromAmanat from "./expense/EditExpenseFromAmanat";
import EditExpenseFromCashInHand from "./expense/EditExpenseFromCashInHand";
import ExpenseDetailsModal from "./expense/ExpenseDetailsModal";
import ManageExpenseFilters from "./ManageExpenseFilters";

const ManageExpense = ({ history }) => {
  const { t } = useTranslation();
  const [selectedExpenseData, setSelectedExpenseData] = useState(null);
  const loggedInUnitId = parseInt(encryptStorage.getItem("loggedInUnitId"));
  const [searchBtnClicked, setSearchBtnClicked] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openDetailsModal, setOpenDetailsModal] = useState(false);
  const [selectedDetailsTransaction, setSelectedDetailsTransaction] = useState(null);
  const [transactionData, setTransactionData] = useState([]);
  const [loading, setLoading] = useState(false);
  const today = new Date();
  const selectedAccountTypeCode =
    selectedExpenseData?.accountTypeCode?.toLowerCase() || "";

  const [values, setValues] = useState({
    unit: { value: loggedInUnitId, lable: "" },
    unitId: loggedInUnitId,
    startDate: new Date(today.getFullYear(), today.getMonth(), 1),
    endDate: new Date(),
    bankAccountId: 0,
    selectedFinanceCategories: [],
    isSubUnits: true,
  });
  const handleSubUnits = (e) => {
    const { value } = e.target;
    let v = value;
    if (value === "true") v = true;
    else v = false;
    setValues({
      ...values,
      isSubUnits: v,
    });
  };

  const handleSearch = (showLoader = true) => {
    setSearchBtnClicked(true);
    if (showLoader) {
      setLoading(true);
    }
    ApiFinance()
      .GetExpenseTransactions({
        ...values,
        startDate: convertToDateString(values.startDate),
        endDate: convertToDateString(values.endDate),
      })
      .then((res) => {
        var convertedData = convertDataFromSnakeCaseToCamelCase(res.data);
        setTransactionData(convertedData);

        if (showLoader) {
          setLoading(false);
        }
      })
      .catch(() => {
        if (showLoader) {
          setLoading(false);
        }
      })
      .finally(() => {
        if (showLoader) {
          setLoading(false);
        }
      });
  };
  const handleOnDelete = (value) => {
    swal({
      title: t("common_delete_message"),
      text: t("common_delete_detail_message"),
      className: GetSelectedLanguage() === "en" ? "" : "ur",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        setLoading(true);
        ApiFinance()
          .DeleteExpense(value)
          .then(() => {
            setLoading(false);
            setTransactionData((prev) =>
              prev.filter(
                (transaction) =>
                  String(transaction.transactionNo) !== String(value),
              ),
            );
            handleSearch(false);
          })
          .catch((err) => {
            console.log(err);
            setLoading(false);
          });
      }
    });
  };

  const viewReceipt = (transactionNo, type) =>
    viewReceiptPdf({ transactionNo, type, t }).catch(() => false);

  return (
    <div className="wrapper-custom wrapper wrapper-content animated fadeInRight">
      <div className="ibox ">
        <ToastContainer
          autoClose={3000}
          bodyClassName={GetSelectedLanguage()}
          closeOnClick
          pauseOnHover={false}
          draggable
        />
        <div className="ibox-title">
          <h5>{<GetLanguageString props="manage_expense" />}</h5>
          <Button
            className={GetCustomStyles().btn_style}
            color="white"
            size="xs"
            onClick={() => history.goBack()}
          >
            {" "}
            <IoArrowBackSharp
              color="#18A689"
              size={15}
              style={{ marginRight: 5, marginBottom: 1 }}
            />
            {<GetLanguageString props="courses_participants_back" />}
          </Button>
        </div>
        <div className="ibox-content">
          <ManageExpenseFilters
            values={values}
            setValues={setValues}
            handleSubUnits={handleSubUnits}
          />

          <Row>
            <Col md="12" className="text-center">
              <div style={{ marginTop: 10 }}>
                <Button
                  color="primary"
                  className="m-l-sm"
                  onClick={handleSearch}
                >
                  {<GetLanguageString props="common_search" />}
                </Button>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      {searchBtnClicked && (
        <>
          {!loading ? (
            <div className="ibox">
              <div className="ibox-content">
                <>
                  {openEditModal && (
                    <>
                      {selectedAccountTypeCode === "amanat_account" ? (
                        <EditExpenseFromAmanat
                          transactionData={selectedExpenseData}
                          setModal={setOpenEditModal}
                          unitId={values.unit.value}
                          onSuccess={handleSearch}
                        />
                      ) : (
                        <EditExpenseFromCashInHand
                          transactionData={selectedExpenseData}
                          setModal={setOpenEditModal}
                          unitId={values.unit.value}
                          onSuccess={handleSearch}
                        />
                      )}
                    </>
                  )}
                  {transactionData.length === 0 ? (
                    <NoResult />
                  ) : (
                    <>
                      <Table>
                        <thead>
                          <tr style={{ borderBottom: "1px solid black" }}>
                            <th className="text-center">#</th>
                            <th
                              className="text-center"
                              style={{ minWidth: 70 }}
                            >
                              {
                                <GetLanguageString props="quick_reports3_unit_name" />
                              }
                            </th>
                            <th className="text-center">
                              {<GetLanguageString props="funds_date" />}
                            </th>

                            <th className="text-center">
                              {
                                <GetLanguageString props="funds_reference" />
                              }
                            </th>
                            <th className="text-center">
                              {
                                <GetLanguageString props="funds_add_fund_amount" />
                              }
                            </th>
                            <th className="text-center">
                              {<GetLanguageString props="transactions_memo" />}
                            </th>
                            <th
                              className="text-center"
                              style={{ minWidth: 70 }}
                            >
                              {<GetLanguageString props="common_action" />}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {transactionData.map((transaction, index) => (
                            <tr key={index}>
                              <td className="text-center">{index + 1}</td>

                              <td className="text-center ur">
                                {transaction.unitName}
                              </td>
                              <td className="text-center">
                                {moment(transaction.date, "YYYY-MM-DD").format(
                                  "DD/MM/YYYY",
                                )}
                              </td>

                              <td className="text-center">
                                {transaction.reference
                                  ?.trim()
                                  .split(/\s+/)
                                  .pop() || ""}
                              </td>

                              <td
                                className={"text-center "}
                                style={{
                                  color:
                                    transaction.amount < 0 ? "red" : "green",
                                }}
                              >
                                <strong>
                                  {new Intl.NumberFormat().format(
                                    transaction.amount,
                                  )}
                                </strong>
                              </td>
                              <td>{transaction.memo || "-"}</td>
                              {transaction.isSyncedWithFinanceSoftware ? (
                                <td className="text-center">
                                  <UncontrolledDropdown>
                                    <DropdownToggle
                                      className="btn btn-default"
                                      tag="button"
                                      style={{ padding: "4px 10px" }}
                                    >
                                      <GetLanguageString props="common_action" />
                                      &nbsp;<b className="caret m-l-xs" />
                                    </DropdownToggle>
                                    <DropdownMenu right>
                                      {transaction.details && transaction.details.length > 0 && (
                                        <DropdownItem
                                          onClick={() => {
                                            setSelectedDetailsTransaction(transaction);
                                            setOpenDetailsModal(true);
                                          }}
                                        >
                                          <BiDetail color="#18A689" size={18} />
                                          &nbsp;&nbsp;<GetLanguageString props="finance_other_expense_entry_details" />
                                        </DropdownItem>
                                      )}
                                      <DropdownItem
                                        onClick={() =>
                                          viewReceipt(
                                            transaction.transactionNo,
                                            "otherExpense"
                                          )
                                        }
                                      >
                                        <IoReceiptSharp color="#5b7cfa" size={18} />
                                        &nbsp;&nbsp;<GetLanguageString props="common_view_receipt" />
                                      </DropdownItem>
                                      {transaction.unitId === loggedInUnitId && (
                                        <>
                                          <DropdownItem
                                            onClick={() => {
                                              setSelectedExpenseData(transaction);
                                              setOpenEditModal(true);
                                            }}
                                          >
                                            <BiSolidEdit color="#3588a2ff" size={18} />
                                            &nbsp;&nbsp;<GetLanguageString props="common_edit" />
                                          </DropdownItem>
                                          {transaction.accountTypeCode !== "amanat_account" && (
                                            <DropdownItem
                                              onClick={() => handleOnDelete(transaction.transactionNo)}
                                            >
                                              <BsTrash3Fill color="#bd3826ff" size={18} />
                                              &nbsp;&nbsp;<GetLanguageString props="common_delete" />
                                            </DropdownItem>
                                          )}
                                        </>
                                      )}
                                    </DropdownMenu>
                                  </UncontrolledDropdown>
                                </td>
                              ) : (
                                <td className="text-center">-</td>
                              )}
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </>
                  )}
                  {openDetailsModal && selectedDetailsTransaction && (
                    <ExpenseDetailsModal
                      transaction={selectedDetailsTransaction}
                      setModal={setOpenDetailsModal}
                    />
                  )}
                </>
              </div>
            </div>
          ) : (
            LoadingSpinner()
          )}
        </>
      )}
    </div>
  );
};

export default withRouter(ManageExpense);
